import app from 'flarum/forum/app';
import IndexPage from 'flarum/forum/components/IndexPage';
import classList from 'flarum/common/utils/classList';
import { extend, override } from 'flarum/common/extend';
import textContrastClass from 'flarum/common/helpers/textContrastClass';
import avatar from "flarum/common/helpers/avatar";

/**
 * 首页模块
 */
export default function indexPageContent() {
  extend(IndexPage.prototype, 'oninit', function () {
    // 防止tag标签没有全部加载完
    app.tagList.load(['parent']).then(() => m.redraw());
  });

  extend(IndexPage.prototype, 'oncreate', function () {
    if (this.element.querySelector('.IndexPage-nav.sideNav')) {
      this.element.querySelector('.IndexPage-nav.sideNav').remove();
    }
  });

  override(IndexPage.prototype, 'hero', function (original) {
    const t = (key) => app.translator.trans('acme-ruko.forum.tags.' + key);
    const tag = this.currentTag();

    if (tag) {
      const color = tag.color();
      const {todayCount, allCount, activeCreators} = tag.data.attributes;
      const user = app.session.user;

      return (
        <header className={classList('Hero', 'TagHero', 'container')}>
          <div className="containerNarrow">
            {user ? avatar(user, { loading: 'eager' }) : ""}
            {/*<img src="https://bbs.djicdn.com/data/attachment/forum/202411/14/152803b6mt6yt6mff10486.jpg" alt="tag-img" />*/}
            <div className="Hero-info">
              <h1 className="Hero-title">
                {tag.name()}
              </h1>
              <div className="Hero-content">
                <span>{t('today_discussion_number')}: {todayCount}</span>
                <span>{t('total_discussion_number')}: {allCount}</span>
                <span>{t('creators_user_number')}: {activeCreators}</span>
              </div>
            </div>
          </div>
        </header>
      );
    }

    return original();
  });
}
